import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './app/App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

/** Known deploy / gateway bases during gradual migration. Longest match wins. */
const KNOWN_BASES = ["/skillm/bot", "/bots", "/bot",process.env.REACT_APP_BASENAME];

function resolveBasename() {
  const pathname = window.location.pathname;
  const match = [...KNOWN_BASES]
    .sort((a, b) => b.length - a.length)
    .find((base) => pathname === base || pathname.startsWith(`${base}/`));
  return match || process.env.REACT_APP_BASENAME || "/bots";
}

const basename = resolveBasename();

root.render(
  <Provider store={store} >
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter >
  </Provider>
);
